// removed by extract-text-webpack-plugin
module.exports = {"component":"_2VZZ2dXO-w0KjXwUiHcSap","messagePlaceholder":"_2xxyCwnahb3ag3gbEd90jm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordList/HealthRecordList.css
// module id = 1286
// module chunks = 0